export default __webpack_public_path__ + "static/Graphik-RegularItalic-Cy-Web-12e77fa75266ea9f025f630da4ea2da1.woff2";